<template>
  <div class="pr-card-application">
    <h1>枫叶卡申请及换新</h1>
    
    <div class="content-section">
      <div class="info-card">
        <h2>枫叶卡介绍</h2>
        <p>枫叶卡PR Card 又称为加拿大永久居民卡（Canada Permanent Resident Card），是加拿大永久居民的官方身份证明文件。枫叶卡的有效期为五年。如果卡过期、遗失、损坏或者被盗，必须申请新卡。加拿大移民法规定，持卡人必须履行其在加拿大的居住义务（Residency Obligation），即在持卡的有效期5年内至少要在加拿大境内实际居住满两年（730天）。持卡人只要没有成为公民，就一直要履行这个居住义务。</p>
      </div>

      <div class="info-card">
        <h2>居住义务的例外情况</h2>
        <p>以下例外情况视同在加拿大居住，其在境外居住的全部或部分天数都算作在加拿大居住的天数：</p>
        <ul>
          <li>陪伴在加拿大境外的加拿大公民配偶、同居伴侣、孩子或父母；</li>
          <li>陪伴在加拿大境外的加拿大PR配偶、同居伴侣、孩子或父母，他们全职在加拿大联邦政府公共管理机构或省公共服务机构、或加拿大公司工作；</li>
          <li>人道同情H&C原因</li>
        </ul>
      </div>

      <div class="info-card">
        <h2>申请条件</h2>
        <ul>
          <li>非加拿大永久居民，需要先申请永久居民身份（PR），即"移民申请"；</li>
          <li>永久居民身份（PR）审核通过后，提交照片和住址以申请；</li>
          <li>申请人必须在加拿大境内递交申请。</li>
        </ul>
      </div>

      <div class="info-card">
        <h2>新移民首次入境</h2>
        <p>新移民在首次入境加拿大时，应将收卡地址告知边境官。或者，在登陆后的180天内把加拿大的有效地址提供给相关部门。通常情况下会在3个月前后，以平邮的方式寄送到入境登记的收卡地址。若在规定的时间内未提供地址，那么就需要申请新枫叶卡，并缴纳申请费用。</p>
      </div>

      <div class="info-card">
        <h2>更新资格</h2>
        <ul>
          <li>过期后，满足5年内住满730天（2年）的居住条件，即可申请新卡；</li>
          <li>遗失、损坏，可以重新申请；</li>
          <li>没有被签发返签；</li>
          <li>不是加拿大公民或印第安人。</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PRCardApplicationView'
}
</script>

<style lang="less" scoped>
.pr-card-application {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;

  h1 {
    text-align: center;
    color: #333;
    margin-bottom: 40px;
    font-size: 32px;
  }

  .content-section {
    display: flex;
    flex-direction: column;
    gap: 30px;
  }

  .info-card {
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    padding: 30px;

    h2 {
      color: #666666;
      margin-bottom: 20px;
      font-size: 24px;
      border-bottom: 2px solid #e6e6e6;
      padding-bottom: 10px;
    }

    p {
      color: #666;
      line-height: 1.8;
      margin-bottom: 20px;
      font-size: 16px;
    }

    ul {
      list-style: none;
      padding: 0;
      margin: 0;

      li {
        position: relative;
        padding-left: 24px;
        margin-bottom: 15px;
        color: #666;
        line-height: 1.6;
        font-size: 16px;

        &:before {
          content: '';
          position: absolute;
          left: 0;
          top: 8px;
          width: 8px;
          height: 8px;
          background: #666;
          border-radius: 50%;
        }

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
}
</style>